/**
 * Açık RFQ pazar yeri ve bölge süzgeci (ADR 0113): ofisin yayın penceresi, "New supplier" rozeti,
 * tedarikçi kartındaki bölgeler.
 */
export const purchasingMarketEn = {
  regions: {
    north_europe: 'North Europe & Baltic',
    west_med: 'West Mediterranean & Iberia',
    east_med: 'East Mediterranean',
    black_sea: 'Black Sea',
    middle_east: 'Red Sea & Gulf',
    indian_ocean: 'Indian Ocean',
    southeast_asia: 'Southeast Asia',
    far_east: 'Far East',
    oceania: 'Australia & Oceania',
    west_africa: 'West Africa',
    southern_africa: 'Southern Africa',
    north_america: 'North America',
    caribbean_central_america: 'Caribbean & Central America',
    south_america: 'South America',
  },
  deliveryRegion: 'Delivery region',
  deliveryRegionHint:
    'Optional. Shown to suppliers and used in their "my regions" filter. Every registered supplier can see an open request; company and vessel names are hidden.',
  choose: 'Choose a region',
  optional: 'Optional',
  partnersLegend: 'Search registered suppliers',
  partnersHint:
    'Find suppliers registered on the portal by company name, port or region. Selected suppliers are invited to this request only.',
  partnerSearch: 'Company name or port',
  partnerSearchPlaceholder: 'e.g. Lion City, Piraeus',
  search: 'Search',
  noPartners: 'No registered supplier found.',
  yourSupplier: 'Your supplier',
  verified: 'Verified',
  rating: '{{average}} / 5 ({{count}})',
  regionUnset: 'Region not set',
  regionFilter: 'Filter by region',
  allRegions: 'All regions',
  serviceRegions: 'Service regions',
  inviteLegend: 'Invite suppliers',
  inviteHint: 'Only approved and active suppliers can be invited.',
  selected: '{{count}} selected',
  noSuppliers: 'All approved suppliers are already invited.',
  noSuppliersInRegion: 'No approved supplier serves this region.',
  alreadyInvited: 'Already invited: {{names}}',
  newSupplier: 'New supplier',
  newSupplierHint:
    'Registered on the portal and quoted on an open request. Not yet one of your suppliers.',
  addSupplier: 'Add to suppliers',
  addSupplierTitle: 'Add {{name}} to your suppliers',
  addSupplierText:
    'The supplier is approved and linked to your company on the portal. From now on it sees your invited and open requests with company and vessel names.',
  addSupplierConfirm: 'Add supplier',
  added: '{{name}} is now one of your suppliers.',
  fieldErrors: {
    REGION_REQUIRED: 'Choose the delivery region.',
    NO_SUPPLIERS: 'Select at least one supplier.',
  },
};

export const purchasingMarketTr: typeof purchasingMarketEn = {
  regions: {
    north_europe: 'Kuzey Avrupa ve Baltık',
    west_med: 'Batı Akdeniz ve İberya',
    east_med: 'Doğu Akdeniz',
    black_sea: 'Karadeniz',
    middle_east: 'Kızıldeniz ve Körfez',
    indian_ocean: 'Hint Okyanusu',
    southeast_asia: 'Güneydoğu Asya',
    far_east: 'Uzak Doğu',
    oceania: 'Avustralya ve Okyanusya',
    west_africa: 'Batı Afrika',
    southern_africa: 'Güney Afrika',
    north_america: 'Kuzey Amerika',
    caribbean_central_america: 'Karayipler ve Orta Amerika',
    south_america: 'Güney Amerika',
  },
  deliveryRegion: 'Teslim bölgesi',
  deliveryRegionHint:
    'İsteğe bağlı. Tedarikçilere gösterilir ve "bölgem" süzgecinde kullanılır. Açık isteği kayıtlı her tedarikçi görür; şirket ve gemi adı gizlidir.',
  choose: 'Bölge seçin',
  optional: 'İsteğe bağlı',
  partnersLegend: 'Kayıtlı tedarikçilerde ara',
  partnersHint:
    'Portala kayıtlı tedarikçileri şirket adı, liman ya da bölgeyle bulun. Seçilenler yalnız bu isteğe davet edilir.',
  partnerSearch: 'Şirket adı ya da liman',
  partnerSearchPlaceholder: 'ör. Lion City, Pire',
  search: 'Ara',
  noPartners: 'Kayıtlı tedarikçi bulunamadı.',
  yourSupplier: 'Tedarikçiniz',
  verified: 'Doğrulanmış',
  rating: '{{average}} / 5 ({{count}})',
  regionUnset: 'Bölge girilmemiş',
  regionFilter: 'Bölgeye göre süz',
  allRegions: 'Bütün bölgeler',
  serviceRegions: 'Hizmet bölgeleri',
  inviteLegend: 'Tedarikçi davet et',
  inviteHint: 'Yalnız onaylı ve etkin tedarikçiler davet edilebilir.',
  selected: '{{count}} seçili',
  noSuppliers: 'Onaylı tedarikçilerin hepsi zaten davetli.',
  noSuppliersInRegion: 'Bu bölgeye hizmet veren onaylı tedarikçi yok.',
  alreadyInvited: 'Zaten davetli: {{names}}',
  newSupplier: 'Yeni tedarikçi',
  newSupplierHint:
    'Portala kendi kaydoldu ve açık bir isteğe teklif verdi. Henüz şirketinizin tedarikçisi değil.',
  addSupplier: 'Tedarikçilere ekle',
  addSupplierTitle: '{{name}} tedarikçilerinize eklensin',
  addSupplierText:
    'Tedarikçi onaylanır ve portalda şirketinize bağlanır. Bundan sonra davetli ve açık isteklerinizi şirket ve gemi adıyla görür.',
  addSupplierConfirm: 'Tedarikçiyi ekle',
  added: '{{name}} artık tedarikçileriniz arasında.',
  fieldErrors: {
    REGION_REQUIRED: 'Teslim bölgesini seçin.',
    NO_SUPPLIERS: 'En az bir tedarikçi seçin.',
  },
};
